<template>
  <div class="price-values supplier">
    <div class="price-stores-lines">
      <div class="price-stores">
        <div class="store-col">
          <!-- <div class="title-col hide-desktop">{{ $t('stock_pcs') }}</div> -->
          <span
            class="name-store"
            :class="{'pointer dashed-bottom': supplier.stock.shipment_days > 0}"
            @mouseover="showSupplier = !showSupplier"
            @mouseleave="showSupplier = false"
          >{{ stockLocaleDataName }}</span>
        </div>
        
        <div class="availability-col hide-phone-DEL">
          <span>{{ supplier.amount_free | integerPart }} {{ $t('pcs') }}</span>
        </div>

        <div class="price-col">
          <!-- <div class="title-col hide-desktop">{{ $t('price_rub') }}</div> -->
          
          <span class="price-digits" v-if="supplier.price > 0">
            {{ supplier.price | integerPart }}<span class="small">{{ supplier.price | fractionalPart }} </span> {{ $t('rub') }}
          </span>
          <span class="price-digits" v-else-if="product.price > 0">
            {{ product.price | integerPart }}<span class="small">{{ product.price | fractionalPart }}</span> {{ $t('rub') }}
          </span>
        </div>

        <transition name="fade">
          <div v-if="supplier.stock.shipment_days > 0" v-show="showSupplier" class="transit-tooltip on-order">
            <span>
              {{ deliveryDeadline(supplier.stock.shipment_days_limit) }}
              {{ supplier.stock.shipment_days }}
              {{ supplier.stock.shipment_days | ending([$t('day_1'), $t('day_2'), $t('day_3')], $i18n.locale) }}</span>
          </div>
        </transition>
      </div>
    </div>

    <div class="order">
      <div class="count">
        <a href="#" @click.prevent="decreaseAmount" :aria-label="$t('decrease')">
          <i class="svg-icon minus icon-pointer" /></a>
        <input-number v-model="amountCart" :value="amountCart" :min-value="0"/>
        <a href="#" @click.prevent="increaseAmount" :aria-label="$t('increase')">
          <i class="svg-icon plus icon-pointer" /></a>
      </div>
      <div class="cart-price">
        <button 
          href="#"
          class="button"
          @click.prevent="addCart"
          :aria-label="$t('add_to_cart')"
          :class="{'disabled': amountCart < 1,'product-cart-exists': supplier.amount_cart > 0}"
        ><i class="svg-icon cart-icon" /><span v-if="supplier.amount_cart > 0">{{ supplier.amount_cart | integerPart }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import InputNumber from '@/components/controls/input-number';

export default {
  components: {
    InputNumber,
  },
  props: ['product', 'supplier'],
  data() {
    return {
      showSupplier: false,
      amountCart: 0,
    }
  },
  computed: {
    stockLocaleDataName() {
      return this.supplier?.stock.stock_translations?.find(x => x.language.slug === this.$i18n.locale)?.name || this.supplier?.stock.name_1c || {};
    },
  },
  methods: {
    deliveryDeadline(dl){
      // const dl = this.stocks.find(x => x.stock_type === stockType)?.shipment_days_limit;
      if (dl === 'gt'){
        return this.$t('delivery_deadline_from') 
      }
      else if (dl === 'lt'){
        return this.$t('delivery_deadline_to') 
      }
      return this.$t('delivery_deadline') 
    },
    decreaseAmount() {
      if (this.amountCart > 0) {
        let amount = this.amountCart - this.product.package_quantity;
        if (amount % this.product.package_quantity) {
          amount += this.product.package_quantity - amount % this.product.package_quantity;
        }
        this.amountCart = amount;
      }
    },
    increaseAmount() {
      let amount = this.amountCart + this.product.package_quantity;
      amount -= amount % this.product.package_quantity;
      this.amountCart = amount;
    },
    addCart() {
      const data = {
        product: this.product.id,
        amount: this.amountCart,
        supplier: this.supplier.stock.id,
        price: this.supplier.price || this.product.price,
      };
      this.$axios.$post('/order/update-cart/', data)
          .then((response) => {
            this.$store.dispatch('setCartExists');
            this.supplier.amount_free = response.amount_free;
            this.supplier.amount_cart = response.amount_cart;
            this.amountCart = 0;
            this.$notify({
              duration: 1000,
              text: this.$t('product_added_to_cart'),
            });
          })
          .catch((e) => {
            let msg = this.$t('unknown_error');
            try {
              msg = e.response.data.detail;
            } catch (e) {
            } finally {
              this.$notify({
                duration: 5000,
                text: msg,
              });
            }
          });
    },
  }
}
</script>